export const reelsFullWithSliderSettings = {
    swipeToSlide: true,
    swipe: true,
    initialSlide: 0,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    rows: 1,
    variableWidth: true,
    adaptiveHeightIncludingInvisible: true,
    responsive: [
        {
            breakpoint: 99999,
            settings: {
                variableWidth: true,
                slidesToShow: 8,
                slidesToScroll: 4,
                arrows: true,
                infinite: true
            }
        },
        {
            breakpoint: 1400,
            settings: {
                variableWidth: true,
                slidesToShow: 7,
                slidesToScroll: 3,
                arrows: true,
                infinite: true
            }
        },
        {
            breakpoint: 1150,
            settings: {
                variableWidth: true,
                slidesToShow: 6,
                slidesToScroll: 3,
                arrows: true,
                infinite: true
            }
        },
        {
            breakpoint: 1024,
            settings: {
                variableWidth: true,
                slidesToShow: 5.5,
                slidesToScroll: 3,
                arrows: false,
                infinite: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                variableWidth: true,
                slidesToShow: 5,
                slidesToScroll: 3,
                arrows: false,
                infinite: true
            }
        },
        {
            breakpoint: 700,
            settings: {
                variableWidth: true,
                slidesToShow: 4,
                slidesToScroll: 3,
                arrows: false,
                infinite: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                variableWidth: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: false,
                infinite: true
            }
        },
        {
            breakpoint: 440,
            settings: {
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 2,
                arrows: false,
                infinite: true
            }
        }
    ]
};
export const reelsFullWithSliderSettings = {
    swipeToSlide: true,
    swipe: true,
    initialSlide: 0,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    rows: 1,
    variableWidth: true,
    adaptiveHeightIncludingInvisible: true,
    responsive: [
        {
            breakpoint: 99999,
            settings: {
                variableWidth: true,
                slidesToShow: 8,
                slidesToScroll: 4,
                arrows: true,
                infinite: true
            }
        },
        {
            breakpoint: 1400,
            settings: {
                variableWidth: true,
                slidesToShow: 7,
                slidesToScroll: 3,
                arrows: true,
                infinite: true
            }
        },
        {
            breakpoint: 1150,
            settings: {
                variableWidth: true,
                slidesToShow: 6,
                slidesToScroll: 3,
                arrows: true,
                infinite: true
            }
        },
        {
            breakpoint: 1024,
            settings: {
                variableWidth: true,
                slidesToShow: 5.5,
                slidesToScroll: 3,
                arrows: false,
                infinite: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                variableWidth: true,
                slidesToShow: 5,
                slidesToScroll: 3,
                arrows: false,
                infinite: true
            }
        },
        {
            breakpoint: 700,
            settings: {
                variableWidth: true,
                slidesToShow: 4,
                slidesToScroll: 3,
                arrows: false,
                infinite: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                variableWidth: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: false,
                infinite: true
            }
        },
        {
            breakpoint: 440,
            settings: {
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 2,
                arrows: false,
                infinite: true
            }
        }
    ]
};
